import { Component, ElementRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertDialogService } from './alert-dialog.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css'],
})
export class AlertDialogComponent implements OnInit {

  public alertDialogState: boolean = false;
  public args: any = null;

  constructor(public dialogService: AlertDialogService, public componentElement: ElementRef) { }

  ngOnInit(): void {

    // reposition page loader
    const alertDialog = this.componentElement.nativeElement.querySelector("div");
    document.body.appendChild(alertDialog);

    //
    // listen for page loader change
    this.dialogService.alert.subscribe((args: any) => {
      this.args = args;
    });
  }

  okay(evt: any) {
    this.dialogService.hide();
  }
}
